import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const GalleryView = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4 7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 4 6.08 4 7.2 4H10v6H4z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14 4h2.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C20 5.52 20 6.08 20 7.2V10h-6z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4 14h6v6H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 18.48 4 17.92 4 16.8z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14 14h6v2.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 20 17.92 20 16.8 20H14z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M10 3.25H7.17c-.535 0-.98 0-1.345.03-.38.03-.736.098-1.073.27A2.75 2.75 0 0 0 3.55 4.752c-.172.337-.24.693-.27 1.073-.03.365-.03.81-.03 1.345V10c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75'
          fill='currentColor'
        />
        <path
          d='M19.249 3.55c-.338-.172-.694-.24-1.074-.27-.365-.03-.81-.03-1.345-.03H14a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V7.17c0-.535 0-.98-.03-1.345-.03-.38-.098-.736-.27-1.073a2.75 2.75 0 0 0-1.2-1.202'
          fill='currentColor'
        />
        <path
          d='M4 13.25a.75.75 0 0 0-.75.75v2.83c0 .535 0 .98.03 1.345.03.38.098.736.27 1.073a2.75 2.75 0 0 0 1.202 1.202c.337.172.693.24 1.073.27.365.03.81.03 1.345.03H10a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75z'
          fill='currentColor'
        />
        <path
          d='M14 13.25a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h2.83c.535 0 .98 0 1.345-.03.38-.03.736-.098 1.073-.27a2.75 2.75 0 0 0 1.202-1.201c.172-.338.24-.694.27-1.074.03-.365.03-.81.03-1.344V14a.75.75 0 0 0-.75-.75z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
